export const operatorSuppliersPath = '/operator'

export const operatorBuyersPath = '/operator/buyers'

/** @deprecated use operatorBuyersPath */
export const operatorRestaurantsPath = operatorBuyersPath

export const operatorSupplierPath = (organizationId: number): string =>
  `/operator/suppliers/${organizationId}`

export const operatorSupplierCatalogPath = (organizationId: number): string =>
  `/operator/suppliers/${organizationId}/catalog`

export const operatorSupplierCatalogImportPath = (organizationId: number): string =>
  `/operator/suppliers/${organizationId}/catalog/import`

export const operatorBuyerPath = (organizationId: number): string =>
  `/operator/buyers/${organizationId}`

/** @deprecated use operatorBuyerPath */
export const operatorRestaurantPath = operatorBuyerPath

export const operatorBuyerPricesPath = (organizationId: number): string =>
  `/operator/buyers/${organizationId}/prices`

export const operatorBuyerPricesImportPath = (organizationId: number): string =>
  `/operator/buyers/${organizationId}/prices/import`

export const operatorBuyerRfqsPath = (organizationId: number): string =>
  `/operator/buyers/${organizationId}/rfqs`

/** @deprecated use operatorBuyerRfqsPath */
export const operatorRestaurantRfqsPath = operatorBuyerRfqsPath

export const operatorRfqPath = (rfqId: number): string => `/operator/rfqs/${rfqId}`
